import React from 'react';
import { graphql } from 'react-relay';

import { t } from '@lingui/macro';

import useI18n from '@zego/i18n/useI18n';
import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';

import CustomerService from '@zego/components/CustomerService';
import DownloadApp from '@zego/components/DownloadApp';
import HomeHowItWorks from '@zego/components/HomeHowItWorks';
import WhyZego from '@zego/components/WhyZego';

const DownloadAppPage = ({ viewer }) => {
  const { i18n } = useI18n();

  return (
    <BaseLayout
      viewer={viewer}
      headerIsInitiallyLightOnDark={false}
      title={i18n._(
        t('Download App Page / Meta title')`Download the Zego App`,
      )}
    >
      <DownloadApp showBackground={false} />
      <HomeHowItWorks />
      <WhyZego />
      <CustomerService />
    </BaseLayout>
  );
};

export default withData(DownloadAppPage, {
  query: graphql`
    query DownloadAppPageQuery($country: String!) {
      viewer {
        ...BaseLayout_viewer @arguments(country: $country)
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
